(function(){
'use strict';

/*
  BGC Purchase Options continuity repair.
  Purpose: during a native Retina cart quantity redraw, keep the SAME existing
  Purchase Options DOM nodes alive and transplant them into the refreshed rows
  before paint. Retina remains authoritative for quantity/cart rendering.
  This code never scrolls, opens/closes the drawer, changes mmenu direction,
  changes selling plans, or changes prices.
*/
if(window.__BGC_DRAWER_PANEL_PRESERVE_2026__)return;
window.__BGC_DRAWER_PANEL_PRESERVE_2026__=1;

var active=null;
var clearTimer=0;

function q(selector,root){return (root||document).querySelector(selector);}
function qa(selector,root){return Array.prototype.slice.call((root||document).querySelectorAll(selector));}
function cartRoot(){return document.getElementById('cart');}
function productRows(root){
  if(!root)return [];
  return qa('li',root).filter(function(row){
    return !!q('a.cart__item',row)&&!!q('.updates[data-id]',row);
  });
}
function directPanel(row){
  if(!row)return null;
  var children=row.children||[];
  for(var i=0;i<children.length;i++){
    if(children[i].classList&&children[i].classList.contains('bgc-drawer-purchase'))return children[i];
  }
  return null;
}
function rowVariant(row){
  var input=row&&q('.updates[data-id]',row);
  if(input&&input.getAttribute('data-id'))return String(input.getAttribute('data-id'));
  return '';
}
function rowLine(row){
  var input=row&&q('.updates[data-line-id]',row);
  var value=input?parseInt(input.getAttribute('data-line-id'),10):0;
  return isFinite(value)&&value>0?value:0;
}
function occurrence(row,rows,variant){
  var same=(rows||[]).filter(function(candidate){return rowVariant(candidate)===variant;});
  return same.indexOf(row);
}
function quantity(row){
  var input=row&&q('.updates',row);
  var value=input?parseInt(input.value,10):NaN;
  return isFinite(value)?value:null;
}
function panelKey(row,panel){
  if(row&&row.dataset&&row.dataset.bgcCartKey)return String(row.dataset.bgcCartKey);
  if(panel&&panel.dataset&&panel.dataset.key)return String(panel.dataset.key);
  return '';
}
function stop(){
  if(active&&active.observer){
    try{active.observer.disconnect();}catch(e){}
  }
  active=null;
  clearTimeout(clearTimer);
  clearTimer=0;
}
function findTarget(snapshot,rows,claimed){
  var i,row;
  if(snapshot.key){
    for(i=0;i<rows.length;i++){
      row=rows[i];
      if(claimed.indexOf(row)!==-1)continue;
      if(row.dataset&&String(row.dataset.bgcCartKey||'')===snapshot.key)return row;
    }
  }
  if(snapshot.line&&snapshot.variant){
    for(i=0;i<rows.length;i++){
      row=rows[i];
      if(claimed.indexOf(row)!==-1)continue;
      if(rowLine(row)===snapshot.line&&rowVariant(row)===snapshot.variant)return row;
    }
  }
  if(snapshot.variant&&snapshot.occurrence>=0){
    var same=rows.filter(function(candidate){return rowVariant(candidate)===snapshot.variant;});
    row=same[snapshot.occurrence]||null;
    if(row&&claimed.indexOf(row)===-1)return row;
  }
  if(snapshot.variant){
    var unique=rows.filter(function(candidate){
      return claimed.indexOf(candidate)===-1&&rowVariant(candidate)===snapshot.variant;
    });
    if(unique.length===1)return unique[0];
  }
  return null;
}
function attach(snapshot,target){
  if(!snapshot||!snapshot.panel||!target)return false;

  if(snapshot.panel.isConnected&&target.contains(snapshot.panel))return true;

  var existing=directPanel(target);
  if(existing&&existing!==snapshot.panel){
    // Another panel is already present before paint; do not create a duplicate.
    return true;
  }

  var anchor=q('a.cart__item',target);
  if(!anchor)return false;

  if(snapshot.key&&target.dataset)target.dataset.bgcCartKey=snapshot.key;
  if(snapshot.variant&&target.dataset)target.dataset.bgcVariant=snapshot.variant;

  if(anchor.nextSibling)target.insertBefore(snapshot.panel,anchor.nextSibling);
  else target.appendChild(snapshot.panel);
  return true;
}
function restore(){
  if(!active)return;
  var root=cartRoot();
  if(!root){stop();return;}

  var rows=productRows(root);
  if(!rows.length)return;
  var claimed=[];

  active.snapshots.forEach(function(snapshot){
    var panel=snapshot.panel;
    if(!panel)return;

    if(panel.isConnected&&root.contains(panel)){
      var currentRow=panel.closest?panel.closest('li'):null;
      if(currentRow)claimed.push(currentRow);
      return;
    }

    var target=findTarget(snapshot,rows,claimed);
    if(!target)return;
    if(attach(snapshot,target))claimed.push(target);
  });
}
function arm(control,row,root){
  var rows=productRows(root);
  var snapshots=[];

  rows.forEach(function(candidate){
    var panel=directPanel(candidate);
    if(!panel)return;
    var variant=rowVariant(candidate);
    snapshots.push({
      panel:panel,
      key:panelKey(candidate,panel),
      variant:variant,
      line:rowLine(candidate),
      occurrence:occurrence(candidate,rows,variant)
    });
  });

  if(!snapshots.length)return;
  stop();

  active={snapshots:snapshots,observer:null};
  if(typeof MutationObserver!=='undefined'){
    active.observer=new MutationObserver(function(){
      // MutationObserver callbacks run before the next paint. Reattach any
      // disconnected preserved panels immediately; our own insertions are safe.
      restore();
    });
    active.observer.observe(root,{childList:true,subtree:true});
  }

  clearTimer=setTimeout(stop,1400);
}
function capture(event){
  if(event.isTrusted===false||!event.target||!event.target.closest)return;
  var control=event.target.closest('#cart .plus, #cart .minus');
  if(!control)return;
  var root=cartRoot();
  if(!root||!root.contains(control))return;
  var row=control.closest('li');
  if(!row||!root.contains(row))return;

  // A minus from quantity 1 removes a whole line and shifts native line indexes.
  // Leave that path entirely to Retina and the existing scroll repair rather
  // than risk transplanting a panel onto the wrong line.
  if(control.classList.contains('minus')){
    var value=quantity(row);
    if(value!==null&&value<=1)return;
  }

  arm(control,row,root);
}

document.addEventListener('click',capture,true);
window.addEventListener('pageshow',stop);
})();
